import React, {useContext, useState} from 'react'
import {checkHotline} from "../../../../services/api/apiCheckHotLine"
import parseToken from "../../../../helpers/parseToken"
import {Button, message, Tooltip} from "antd"
import {UndoOutlined} from '@ant-design/icons';
import {formatDate} from "../../../../helpers/formatDate"
import CheckHotlineContext from "../../context/CheckHotlineContext"

CheckHotlineItem.propTypes = {}

function CheckHotlineItem(props) {
    const {item, index} = props
    const [loading, setLoading] = useState(false)
    const {onChangeValueId, onShowModalListHotline} = useContext(CheckHotlineContext)

    const _onShowListDetail = (type, id) => {
        onChangeValueId({type, id})
        onShowModalListHotline()
    }

    const _checkListHotlineAgain = async (listCheckId) => {
        setLoading(true)

        try {
            const decodeToken = parseToken()
            const response = await checkHotline(listCheckId, decodeToken.sub)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }

            setLoading(false)
            message.success('Đã gửi yêu cầu check. Vui lòng đợi trong 1-2 phút rồi refresh lại màn hình này')
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return (
        <tr className="CustomersItem">
            <td className='text-center'>{index + 1}</td>
            <td>{item?.listCheckName}</td>
            <td>{formatDate(item?.listCreatedAt)}</td>
            <td>{formatDate(item?.listCheckedAt)}</td>
            <td className='text-center'>
                <span className='custom-number normal-number'
                      onClick={() => _onShowListDetail(1, item?.id)}>{item?.numHotline}</span>
            </td>
            <td className='text-center'>
                <span className='custom-number success-number'
                      onClick={() => _onShowListDetail(2, item?.id)}>{item?.numSuccessHotline}</span>
            </td>
            <td className='text-center'>
                <span className='custom-number warning-number'
                      onClick={() => _onShowListDetail(11, item?.id)}>{item?.numDuplicate}</span>
            </td>
            <td className='text-center'>
                <span className='custom-number faild-number'
                      onClick={() => _onShowListDetail(3, item?.id)}>{item?.numFailHotline}</span>
            </td>
            <td className='text-center'>
                <Tooltip title="Yêu cầu check lại số hotline">
                    <Button
                        onClick={() => _checkListHotlineAgain(item?.id)}
                        loading={loading}
                        disabled={loading}
                        icon={<UndoOutlined/>}
                    ></Button>
                </Tooltip>
            </td>
        </tr>
    )
}

export default CheckHotlineItem